import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { catchError, from, map, Observable, of } from 'rxjs';
import { BackendErrorType } from '../services/errors/backend.errors';
import { LandingpageConfigurationStateService } from '../services/state/landingpage-configuration-state.service';

@Injectable({
  providedIn: 'root',
})
/***
 routes either to OverviewComponent, Error page or AccessToken Component, depending on the validity of the token passed in the url
 ***/
export class CheckForTokenGuard implements CanActivate {
  private router = inject(Router);
  private logger = inject(NGXLogger);
  private landingpageConfigurationStateService = inject(LandingpageConfigurationStateService);

  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree | boolean> | UrlTree {
    if (!route.queryParamMap.has('code')) {
      return this.router.parseUrl('/');
    }
    const token = route.queryParamMap.get('code')!;
    return this.isTokenValid(token);
  }

  isTokenValid(token: string): Observable<UrlTree | boolean> {
    return from(this.landingpageConfigurationStateService.fetchLandingpageConfigurationForToken(token)).pipe(
      map(() => {
        this.logger.debug('Request Landingpage Configuration:', {
          requestParam: token,
        });
        return this.router.parseUrl('/case');
      }),
      catchError((error: Error) => {
        if (error.message === BackendErrorType.ALREADY_SENT) {
          return of(this.router.parseUrl('already-sent'));
        } else if (error.message === BackendErrorType.VERIFICATION_ERROR) {
          return of(this.router.parseUrl('verification-error'));
        } else if (error.message === BackendErrorType.SERVER_ERROR) {
          // errorInterceptor already navigates to the error page; cancel this navigation
          // without racing it with a second one.
          return of(false);
        }
        return of(this.router.parseUrl('/'));
      }),
    );
  }
}
